import React from "react";
import InsightsOutlinedIcon from "@mui/icons-material/InsightsOutlined";
import { useClaims } from "../../../../../auth/ClaimsProvider";
import { ShiOnePermission } from "../../../../../auth/authorizationTypes";
import { useFeatureFlag } from "shared-ui/src/utils/FeatureFlagHelper";
import { MANUFACTURER_INSIGHTS_FEATURE_FLAG } from "@features/manufacturer-insights/constants";

export function useGetManufacturerInsightsNavItems() {
  const { hasPermission } = useClaims();
  const { enabled } = useFeatureFlag(MANUFACTURER_INSIGHTS_FEATURE_FLAG);

  return [
    {
      id: "manufacturer-insights",
      type: "Link",
      displayName: "Insights",
      visible: Boolean(
        enabled && hasPermission(ShiOnePermission.manufacturerInsightsRead),
      ),
      icon: <InsightsOutlinedIcon />,
      path: "/manufacturer-insights",
    },
  ];
}
